module.exports = __webpack_public_path__ + "img/ghest.f88815e1.jpg";